import {PureComponent} from 'react'
import {Field, reduxForm} from 'redux-form'

import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx'
import Loader from '../../../../shared/components/Loader/Loader.jsx'

import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js'
import Quill from "../../Form/Field/Quill.jsx"


export const name = 'FreelanceInterviewAppreciationForm'

class FreelanceInterviewAppreciationForm extends PureComponent {


  render() {
    return <div id={name}>
      <form autoComplete="off" onSubmit={this.props.handleSubmit}>
        <div className="row">
          <div className="col-lg-12">
            <Field
              name="freelance.agent_remark"
              component={Quill}
            />
          </div>
        </div>
        <input className="d-none" type="submit"/>
        <FormGlobalErrors className="mt-0" errors={this.props.error}/>
      </form>
      <Loader visible={this.props.submitting || this.props.triggerSubmit}/>
    </div>
  }
}

export default reduxForm({
  form: name,
  onSubmitFail: createOnSubmitFailHandler(name)
})(FreelanceInterviewAppreciationForm)
